import { Categorie } from "../../../../types/features/Post";
import TableList, { SelectAction } from "../../../ui/TableList";
import CategorieRow from "./CategorieRow";

interface CategoriesListProps {
  categories: Categorie[];
  onAction: (categorie: Categorie) => void;
  onSelectCategories?: (selectedCategories: Categorie[]) => void;
  selectable?: boolean;
  selectActions?: SelectAction[];
}

export default function CategoriesList({
  categories,
  onAction,
  onSelectCategories,
  selectable = false,
  selectActions,
}: CategoriesListProps) {
  const columns = [
    { header: "Catégorie", className: "w-2/5" },
    { header: "Nom (EN)", className: "hidden sm:table-cell w-1/5" },
    { header: "Description", className: "hidden md:table-cell w-1/3" },
    { header: "Articles", className: "hidden lg:table-cell w-1/6 text-center" },
  ];

  return (
    <TableList
      items={categories}
      columns={columns}
      getId={(categorie) => categorie.id}
      onAction={onAction}
      onSelectItems={onSelectCategories}
      selectable={selectable}
      emptyMessage="Aucune catégorie trouvée"
      actionColumn={true}
      selectActions={selectActions}
      renderRow={(categorie, isSelected, onSelect) => (
        <CategorieRow
          key={categorie.id}
          categorie={categorie}
          onAction={onAction}
          onSelect={onSelect}
          isSelected={isSelected}
          selectable={selectable}
        />
      )}
    />
  );
}
